import { Alert, Box, Text } from 'braid-design-system';
import { useState } from 'react';

interface Props {
  message: string;
  tone: 'promote' | 'info' | 'positive' | 'caution' | 'critical';
}

const InfoBanner = ({ message, tone }: Props) => {
  const [showAlert, setShowAlert] = useState(true);

  if (!showAlert) {
    return null;
  }

  return (
    <Box paddingTop="gutter">
      <Alert
        tone={tone}
        onClose={() => {
          setShowAlert(false);
        }}
        closeLabel="Close info alert"
      >
        <Text>{message}</Text>
      </Alert>
    </Box>
  );
};

export default InfoBanner;
